import script from "./contactCard.vue?vue&type=script&lang=js"
export * from "./contactCard.vue?vue&type=script&lang=js"

import "./contactCard.vue?vue&type=style&index=0&id=69cb869e&lang=css"
import "./contactCard.vue?vue&type=style&index=1&id=69cb869e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cb869e"]])

export default __exports__